import { Vue, prop, Options } from 'vue-class-component';
import { Transition } from 'vue';
import { resetScrollLocks, lockScroll } from '@/common/helpers';
import styles from './styles.module.scss';

class ModalProps {
	onBackdropClick = prop<Function>({ default: () => () => undefined })

	isOpen = prop<boolean>({ default: false })
}

@Options({
	name: 'Modal',
})
export class Modal extends Vue.with(ModalProps) {
	handleBackdropClick(event: Event) {
		this.onBackdropClick(event);
	}

	openTransitionStart() {
		lockScroll(this.$refs.modal as HTMLElement);
	}

	closeTransitionEnd() {
		resetScrollLocks();
	}

	render() {
		return (
			<Transition name="modal_fade"
				onEnter={ this.openTransitionStart } onAfterLeave={ this.closeTransitionEnd }>
				{ this.isOpen
				&& <div class={ styles.modal }>
					<div class={ styles.modalBackdrop } onClick={ this.handleBackdropClick }/>
					<div class={ styles.modalContent } ref="modal">
						{ this.$slots.default && this.$slots.default() }
					</div>
				</div> }
			</Transition>
		);
	}
}
